export const red = '#e85a36';
export const gray = '#35343f';
